import LoadingContainer from "components/LoadingContainer";

const RedirectLayout = () => <LoadingContainer />;

export default RedirectLayout;
